import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fc40f23&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6fc40f23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc40f23",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterResultsPane: require('/usr/src/motec/components/FilterResults/Pane.vue').default,Spinner: require('/usr/src/motec/components/Spinner.vue').default})
